.modalFormButtonContainer {
    display: flex;
    justify-content: flex-end;
    gap: 20px;
    margin-top: 20px;
}

.dateContainer {
    display: flex;
    gap: 20px;
}